export const COLORS = {
	OUTLOOK_BLUE: '#127CD6',
	OUTLOOK_LIGHT_BLUE: '#58b8fe',
	OUTLOOK_DARK_BLUE: '#005a9e',
	DARK_BLUE_BTN: '#5dabdb',
	CURIOUS_BLUE: '#1490DF',
	PICTON_BLUE: '#28A8EA',
	DEEP_SAPPHIRE_BLUE: '#0A2767',
	YELLOW: '#e8b864',
	BG_GREY_LIGHT: '#FAF9F8',
	BG_GREY_DARK: '#666666',
	ICON_BLUE_COLOR: '#54A7D9',
	PURPLE: '#CC93D2',
	GREEN: '#127d43',
	RED: 'rgb(164, 38, 44)',
	RED_ON_DARK: '#F1707B',
	BORDER_COLOR: 'rgba(174, 180, 189, 1)',
	OUTLOOK_BLACK_FONT: '#333333',
	OUTLOOK_PRIMARY_BUTTON_COLOR: '#5DABDB',
	OUTLOOK_PRIMARY_BUTTON_BORDER_COLOR: '#5596C4',
	DATA_GRID_CELL_BACKGROUND: '#faf9f8',
	LABEL_HEADER_TEXT_COLOR: '#5E6367',
	ALICE_BLUE: '#E1EFFF',
	BORDER_COLOR_GRAY: '#797979',
	WHITE: '#ffffff',
};
